import { Helmet } from 'react-helmet'
import FaqsBanner from '../assets/landing/FaqsBanner.webp'
import FaqsBannerMobile from '../assets/landing/FaqsBannerMobile.webp'
import { useMediaQuery } from '@uidotdev/usehooks'
import { Accordion } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

const Faqs = () => {
  const isMobile = useMediaQuery('(max-width: 768px)')
  const navigate = useNavigate()

  const handleClick = () => {
    navigate('/#how-to-enter')
  }

  const handleInspirationClick = () => {
    navigate('/inspiration')
  }

  return (
    <main>
      <Helmet>
        <title>FAQ | RFDS (Queensland Section) + Elders</title>
      </Helmet>
      <section className="Inspiration__Banner">
        <img
          className="Inspiration__Banner__Image"
          src={isMobile ? FaqsBannerMobile : FaqsBanner}
          alt="bannerBackground"
        />
        <p className='Inspiration__Banner__Textfaqs text-center px-3'>Frequently asked questions</p>
      </section>
      <section className="Faqs" >

        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>How do I upload my video?</Accordion.Header>
            <Accordion.Body>
              To submit your video into the competition,{' '}
              <button onClick={handleClick}>
                click here.
              </button>
              <br />
              Please note that for your video to be successfully accepted into the competition it must:
              <ul>
                <li>not be longer than 2 minutes in length</li>
                <li>contain the Outback Explorer Competition sticker</li>
                <li>be uploaded to a publicly accessible YouTube, TikTok, or Instagram account</li>
              </ul>
              If you experience any issues creating or uploading your video, please contact us via email at <a href="mailto:competitions@rfdsqld.com.au">competitions@rfdsqld.com.au</a>.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>What should I do if my video is rejected?</Accordion.Header>
            <Accordion.Body>
              Don&apos;t panic! If your video has been rejected, check the rejection email for an explanation and instructions on how to fix and resubmit your video.
              <br />
              <br />
              If you have any issues creating or uploading your video, please contact us via email at <a href="mailto:competitions@rfdsqld.com.au">competitions@rfdsqld.com.au</a>.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>When will the competition end?</Accordion.Header>
            <Accordion.Body>
              Submissions for the Outback Explorer Competition will close on Tuesday 26 August at 11:59pm.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3">
            <Accordion.Header>When will the winners be announced?</Accordion.Header>
            <Accordion.Body>
              After our judging panel has reviewed all video entries, the winners for all prize categories—including Judge’s Pick, People’s Choice, and Voting Account Lucky Draw—will be announced by Tuesday 30 September.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="4">
            <Accordion.Header>What should my video be about?</Accordion.Header>
            <Accordion.Body>
              We want to see what your life looks like in regional Queensland!
              <br/>
              <br/>
              Whether it&apos;s your daily routine, breathtaking landscapes, community events, or quiet moments in your favourite spot—share what makes your slice of Queensland special.
              <br />
              <br />
              Need a some inspiration? Head to our{' '}
              <button onClick={handleInspirationClick}>
                Inspiration page
              </button>
              {' '}and use the idea generator to spark ideas and help shape your video submission.
              <br />
              <br />
              Your everyday could be worth $10,000—so hit record and show us your world.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="5">
            <Accordion.Header>Which social media platforms can I post my video from?</Accordion.Header>
            <Accordion.Body>
              As part of the submission process, your video must be posted on YouTube, Instagram, or TikTok.
              <br />
              <br />
              When submitting your video entry form, please provide the embed link from your chosen social media platform.
              <br />
              <br />
              <strong>Where to find the embed link for your video:</strong>
              <br />
              <br />
              <strong>YouTube:</strong>
              <ol>
                <li>Go to your video on YouTube.</li>
                <li>Click on the &quot;Share&quot; button below the video.</li>
                <li>Copy the link provided.</li>
              </ol>
              <strong>TikTok:</strong>
              <ol>
                <li>Open your video on TikTok.</li>
                <li>Tap the &quot;Share&quot; icon (arrow pointing right).</li>
                <li>Select the &quot;Copy Link&quot; option.</li>
              </ol>
              <strong>Instagram:</strong>
              <ol>
                <li>Go to your video post on Instagram.</li>
                <li>Tap the three dots (ellipsis) on the top right corner of the post.</li>
                <li>Select &quot;Copy Link&quot; from the menu.</li>
              </ol>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="6">
            <Accordion.Header>My video has been submitted but is not playing on the competition website.</Accordion.Header>
            <Accordion.Body>
              If you have successfully entered your video into the competition but notice it is not playing or shows &quot;video unavailable,&quot; please check the following:
              <br />
              <br />
              <ol>
                <li>Ensure your social media profile is set to public.</li>
                <li>Ensure your video does not use any licensed music.</li>
              </ol>
              If these criteria are met and your video is still not playing, please contact us via email at <a href="mailto:competitions@rfdsqld.com.au">competitions@rfdsqld.com.au</a>.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="7">
            <Accordion.Header>Where do I find my embed link for YouTube, Instagram, or TikTok?</Accordion.Header>
            <Accordion.Body>
              To enter the competition, we require you to submit an embed link for your video. Here&apos;s how to find it:
              <br />
              <br />
              <strong>YouTube:</strong>
              <ol>
                <li>Go to your video on YouTube.</li>
                <li>Click on the &quot;Share&quot; button below the video.</li>
                <li>Copy the link provided.</li>
              </ol>
              <strong>TikTok:</strong>
              <ol>
                <li>Open your video on TikTok.</li>
                <li>Tap the &quot;Share&quot; icon (arrow pointing right).</li>
                <li>Select the &quot;Copy Link&quot; option.</li>
              </ol>
              <strong>Instagram:</strong>
              <ol>
                <li>Go to your video post on Instagram.</li>
                <li>Tap the three dots (ellipsis) on the top right corner of the post.</li>
                <li>Select &quot;Copy Link&quot; from the menu.</li>
              </ol>
            </Accordion.Body>
          </Accordion.Item>

          {/* <Accordion.Item eventKey="8">
            <Accordion.Header>I have downloaded the video frame but cannot see it on my device.</Accordion.Header>
            <Accordion.Body>
              <strong><u>On iPhone/iPad</u>:</strong>
              <br />
              If downloading on iPhone, your device may save the video frame to your “Files” app.
              <br />
              <br />
              To add the video frame to your camera roll/photos app:
              <br />
              <ul style={{margin: 0}}>
                <li>Locate the file in your “Files” app.</li>
                <li>Click the “Share” button at the bottom left of the screen.</li>
                <li>Click “Save Video”.</li>
                <li>Open your “Photos” app and select “Albums” then “Recent”.</li>
                <li>The video frame will then be visible in your Camera Roll/Photos app.</li>
              </ul>
              <br />
              <br />
              <strong><u>On Android mobile phone/tablet</u>:</strong>
              <br />
              If downloading on Android, your device should save the video frame to your Google Photos app.
              <br />
              <br />
              <br />

              <strong><u>On a laptop/desktop</u>:</strong>
              <br />
              The location of the video frame will depend on the folder you selected to download the file to.
              <br />
              To easily find the file on your computer, try entering “Outback” into your computer’s search function.
              <br />
              <br />
              <br />
              If you are experiencing issues, please contact our team at <a href="mailto:competitions@rfdsqld.com.au">
                <strong>competitions@rfdsqld.com.au</strong>
              </a>
              &nbsp;and we will be happy to help.
            </Accordion.Body>
          </Accordion.Item> */}
        </Accordion>
      </section>
    </main>
  )
}

export default Faqs